import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import React from "react";
import { dashboardColors } from "routes/utils";

interface ProgressItem {
  name: string;
  value: number;
}

interface ProgressBarChartProps {
  data: ProgressItem[];
  isFetching: boolean;
}

export const ProgressBarChart: React.FC<ProgressBarChartProps> = ({ data, isFetching }:any) => {
  if (!data || data.length === 0) return <p>No data available</p>;
  const progressdata=((data?.res?.salesProgressData!=null)?data?.res?.salesProgressData:[])|| [];
  
  // Calculate total for percentage stacking
  // Assign colors dynamically
  const colors = dashboardColors;

  const options: Highcharts.Options = {
    chart: { type: "bar", height: 120 },
    title: { text: undefined },
    xAxis: { visible: false },
    yAxis: { visible: false, max: 100 },
    legend: { enabled: false },
    credits: { enabled: false },
    tooltip: {
       headerFormat: '<span style="font-size: 14px"><b>{point.name}</b></span><br/>',
      pointFormat: "<b>{point.percentage:.1f}%</b> ({point.y} kg)" },
    plotOptions: {
      series: { stacking: "percent", borderWidth: 0 },
      bar: { dataLabels: { enabled: true, format: "{point.percentage:.1f}%" } },
    },
    series: progressdata.map((item:any, idx:any) => ({
      type: "bar",
      name: item.name,
      data: [
      {
        y: item.value,     // numeric value
        name: item.name,   // this enables {point.name} in tooltip
      },
    ],
      color: colors[idx % colors.length],
    })),
  };

  return (
    <div style={{ width: "100%", maxWidth: 500, margin: "0 auto" }}>
      <h2>Sales Progress</h2>
      {isFetching ? (
        <p>Loading...</p>
      ) : (
        <>
          <HighchartsReact highcharts={Highcharts} options={options} />

          {/* Labels */}
          <div style={{ marginTop: 10 }}>
            {progressdata.map((item:any, idx:any) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: 12,
                      height: 12,
                      borderRadius: "50%",
                      backgroundColor: colors[idx % colors.length],
                    }}
                  />
                  <span>{item.name}</span>
                </div>
                <span>{item.value} kg</span>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
};
